<template>
    <UiCard class="IDCard text-gray-600 relative d-flex flex-column">
        <div class="row flex-1">
            <div class="col-4">
                <div 
                    class="img-mask rounded" 
                    :style="{ 
                        backgroundImage: 'url(' + propOrPlaceholder(imageLink,userPlaceholder) + ')' 
                    }"
                ></div>
            </div>
            <div class="col pl-0">
                <div class="text-lg font-semibold mt-1">
                    <span v-if="!!title" >{{ title }}</span>
                    <UiSkeleton v-else style="max-width:150px; min-height: 1.5em;"></UiSkeleton>
                </div>
                <div class="mt-3">
                    <span v-if="!!comment" >{{ comment }}</span>
                    <UiSkeleton v-else style="max-width:120px; min-height: 1.25em;"></UiSkeleton>
                </div>
            </div>
        </div>
        <div class="text-mono">
            <span v-if="!!serial" >{{ serial }}</span>
            <UiSkeleton v-else style="max-width:120px; min-height: 1.25em;"></UiSkeleton>
        </div>

    </UiCard>
</template>

<script>
    var userPlaceholderG = require("@/assets/img/user-no-img.png");
    import UiCard from '@/components/ui/Card';
    import UiSkeleton from '@/components/ui/Skeleton';

    export default {
        name: 'idcard',
        props: ['imageLink', 'title', 'comment', 'serial'],
        data: () => ({
            userPlaceholder: userPlaceholderG
        }),
        components: {
            UiCard,
            UiSkeleton,
        },
        methods: {
            propOrPlaceholder: function (prop, placeholder) {
                if (prop == "" || prop == null) {
                    return placeholder;
                }
                else {
                    return prop;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
